import { type ComponentType, lazy } from 'react';

/** Share the same import promise between intent preloading and React.lazy. */
export function lazyPage(load: () => Promise<{ default: ComponentType }>) {
  let pending: ReturnType<typeof load> | undefined;
  function preload() {
    pending ??= load().catch((error) => {
      pending = undefined;
      throw error;
    });
    return pending;
  }
  return Object.assign(lazy(preload), { preload });
}
